'use client';

import React from 'react';
import Link from 'next/link';

export function BackToHomeFloating(): React.ReactElement {
  return (
    <Link
      href="/"
      aria-label="Back to home"
      title="Back to home"
      className="inline-flex items-center gap-2 rounded-full border border-neutral-200 dark:border-neutral-800 bg-white/70 dark:bg-neutral-900/60 px-3 py-1.5 text-sm text-neutral-700 dark:text-neutral-200 shadow-sm hover:bg-white dark:hover:bg-neutral-900 backdrop-blur-sm"
      prefetch
    >
      <span aria-hidden>←</span>
      <span>Back to home</span>
    </Link>
  );
}
